<template>
  <div>
    <!-- <div class="success-percentage">
      <div class="progress-pipes">
        <div
          v-for="index in 40"
          :key="index"
          class="pipe"
          :class="{
            completed: index <= Math.round((successfulTrainings / totalTrainings) * 40)
          }"
        ></div>
      </div>
      <div class="progress-text">
        {{ Math.round((successfulTrainings / totalTrainings) * 100) }}% completed
      </div>
    </div> -->
    <section
      class="section content-grid-collection"
      ref="contentGridFilterCollectionElem"
      data-content-type="user-training"
    >
      <div class="container">
        <div
          class="main-filter-wrapper buttons"
          v-if="collectionFilter && collectionFilterType == 'buttons'"
        >
          <div class="inner-wrapper">
            <Flickity
              ref="flickity"
              :options="flickityOptions"
              class="btns-wrapper"
              v-for="filterType in catFilters"
              :key="filterType.name"
            >
              <li>
                <button
                  value="*"
                  @click="onFilterClick('*', collectionFilter)"
                  :class="{ active: '*' === this.filterVal[filterType.name] }"
                >
                  All
                </button>
              </li>
              <li v-for="child in filterType.children" :key="child.id">
                <button
                  :value="child.id"
                  :class="{
                    active: child.id === this.filterVal[filterType.name]
                  }"
                  @click="onFilterClick(child.id, collectionFilter)"
                >
                  {{ child.enumValue }}
                </button>
              </li>
            </Flickity>
          </div>
        </div>
        <div class="main-filter-wrapper dropdown" v-else-if="collectionFilter">
          <button
            @click="showMobileFilterFunction()"
            class="show-filter-btn"
            :class="{ 'show-mobile-filter': showMobileFilter }"
          >
            Filter
          </button>
          <div class="inner-wrapper" :class="{ 'show-mobile-filter': showMobileFilter }">
            <!-- <button v-if="displayResetBtn" class="reset-all-filters" @click="resetAllFilters()">Reset
                            all</button> -->

            <div class="filter-wrapper" v-for="filterType in catFilters" :key="filterType.name">
              <select @change="onFilterChange" v-model="filterVal[filterType.name]">
                <option selected="selected" value="*">
                  {{ changeFilterTitle(filterType.name) }}
                </option>
                <option v-for="child in filterType.children" :key="child.id" :value="child.id">
                  {{ child.enumValue }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column-wrapper">
          <div class="column grid-collection user-training-collection" :class="{ list: displayType === 'list' }">
            <transition name="slow-fade">
              <div class="items-wrapper">
                <ul>
                  <li
                    class="user-training"
                    :class="{ list: displayType === 'list' }"
                    v-for="item in itemContentArray"
                    :key="item.id"
                  >
                    <UserTrainingOverviewListItem
                      :data="item"
                      :observer="observer"
                      v-if="displayType === 'list'"
                    />
                    <UserTrainingOverviewItem :data="item" :observer="observer" v-else />
                  </li>
                </ul>
              </div>
            </transition>

            <transition name="slow-fade">
              <div class="message no-items-found" v-if="showNoItemsFound && !showLazyLoadSpinner">
                No content found..
              </div>
            </transition>
            <transition name="fade">
              <div class="lazyload-spinner" v-if="showLazyLoadSpinner">
                <ul>
                  <!-- <li></li> -->
                  <!-- <li></li>
                  <li></li> -->
                  <!-- <li></li>
                  <li></li>
                  <li></li> -->
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { defineComponent, computed, ref, onMounted } from 'vue'
import { fetchNestedEnumValues, fetchTrainingOverview } from '@streampac.io/chef_sp_1'

import Flickity from '@/components/Flickity/index.vue'
import { useGlobalStore } from '@/stores/global'
import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useTrainingProgress } from '@/composables/userTrainingProgress'

import UserTrainingOverviewItem from '@/components/UserTrainingOverviewItem/index.vue'
import UserTrainingOverviewListItem from '@/components/UserTrainingOverviewListItem/index.vue'

export default defineComponent({
  name: 'UserTrainingCollection',
  components: {
    Flickity,
    UserTrainingOverviewItem,
    UserTrainingOverviewListItem
  },
  props: {
    collectionFilter: {
      type: Object,
      required: false
    },
    paging: {
      type: Object,
      required: true
    },
    searchParams: {
      type: String,
      required: false
    },
    collectionFilterType: {
      type: String,
      required: false
    },
    displayType: {
      type: String,
      required: false
    }
  },
  emits: [],
  setup(props) {
    const globalStore = useGlobalStore()
    const showMobileFilter = ref(false)
    const showNoItemsFound = ref(false)
    const loadedAllItemFound = ref(false)
    const observer = ref(null)
    const totalItems = ref(0)
    const totalLoadedItems = ref(0)
    const catFilters = ref([])
    const filterVal = ref([])
    const showLazyLoadSpinner = ref(false)
    const data = ref(null)
    const itemContentArray = ref([])

    const fetchDataParams = ref({
      filter: {
        searchTerm: '',
        queryCondition: 'AND',
        type: 'PublicTraining;CustomerGroupTraining',
        typeQueryCondition: 'OR'
      },
      paging: {
        pageNumber: 1,
        pageSize: 1
      },
      orderBy: {
        orderByField: 'sortOrder',
        orderDesc: false
      }
    })

    const flickityOptions = ref({
      initialIndex: 0,
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      draggable: true,
      groupCells: true,
      prevNextButtons: false,
      watchCSS: true
    })
    const displayResetBtn = ref(false)

    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const contentGridFilterCollectionElem = ref(null)

    const successPercentage = ref(0)
    const totalTrainings = ref(0)
    const successfulTrainings = ref(0)

    onMounted(() => {
      observer.value = new IntersectionObserver(onElementObserved, {
        //root: overviewCollectionElem.value, //Not needed??
        rootMargin: '0px',
        threshold: [0.5] // Trigger when 50% of the element is visible
      })

      if (props.searchParams) {
        fetchDataParams.value.filter.searchTerm = props.searchParams
      }

      if (props.paging) {
        fetchDataParams.value.paging.pageNumber = props.paging.pageNumber
        fetchDataParams.value.paging.pageSize = props.paging.pageSize
      }

      if (props.collectionFilter) {
        props.collectionFilter.forEach((filterType) => {
          filterVal.value[filterType] = '*'
        })

        fetchNestedEnumValues(isAuthenticated.value).then((response) => {
          props.collectionFilter.forEach((filterType) => {
            response.forEach((name) => {
              if (name.enumName === filterType) {
                let enumObj = {
                  name: name.enumName,
                  children: name.enumerationValues
                }

                catFilters.value.push(enumObj)
              }
            })
          })
        })
      }

      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)

      if (queryString && queryString !== '') {
        for (const [key, value] of urlParams.entries()) {
          if (value && value !== '') {
            filterVal.value[key] = value
          }
        }
      }

      setTimeout(() => {
        changeFetchParams(filterVal.value)
      }, 100)

      if (props.onlyShowFree && props.onlyShowFree === true) {
        fetchDataParams.value.filter.free = true
      }
    })

    const onElementObserved = (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          observer.value.unobserve(target)
          totalItems.value += 1
          totalLoadedItems.value += 1
        }
      })

      if (totalItems.value === fetchDataParams.value.paging.pageSize) {
        setTimeout(() => {
          fetchDataParams.value.paging.pageNumber += 1
          fetchUserTraining(fetchDataParams.value.paging.pageNumber)
        }, 50)

        totalItems.value = 0
      }
    }

    const changeFilterTitle = (val) => {
      return val === "Nr of Video's" ? 'Classes' : val
    }

    const onFilterChange = () => {
      changeFetchParams(filterVal.value)
      totalItems.value = 0
      totalLoadedItems.value = 0
      checkDisplayResetFilterBtn()
    }

    const onFilterClick = (val, collectionFilter) => {
      filterVal.value[collectionFilter] = val
      onFilterChange()
    }

    const fetchUserTraining = (val) => {
      showLazyLoadSpinner.value = true
      fetchDataParams.value.paging.pageNumber = val

      if (val === undefined) fetchDataParams.value.paging.pageNumber = 1

      fetchTrainingOverview(
        isAuthenticated.value,
        fetchDataParams.value,
        '?isFlattenFieldsVisible=true&isUserTrainingIncluded=true',
        true
      ).then((response) => {
        const paginationHeaders = JSON.parse(response.headers['x-pagination'])

        const { updateTrainingData } = useTrainingProgress()

        // Update with new data
        updateTrainingData(response.data)

        if (paginationHeaders.TotalCount === 0) {
          showNoItemsFound.value = true
        }

        if (paginationHeaders.TotalCount === totalLoadedItems.value) {
          loadedAllItemFound.value = true
        }

        data.value = response.data
        processFetch()

        setTimeout(() => {
          showLazyLoadSpinner.value = false
        }, 500)
      })

      if (props.collectionFilter) {
        changeUrlParameters()
      }
    }

    const processFetch = () => {
      if (data.value) {
        data.value.forEach((item) => {
          itemContentArray.value.push(item)
        })
      }
    }

    const changeFetchParams = (val) => {
      data.value = null
      itemContentArray.value = []
      fetchDataParams.value.paging.pageNumber = 1
      loadedAllItemFound.value = false
      totalLoadedItems.value = 0
      showLazyLoadSpinner.value = false
      showNoItemsFound.value = false

      const valValuesArray = Object.values(val)
      const filteredArray = valValuesArray.filter((e) => e !== '*')
      const stringifyVal = filteredArray.toString().replaceAll(',', '; ')

      fetchDataParams.value.filter.searchTerm = stringifyVal
      fetchUserTraining(1)
    }

    const changeUrlParameters = () => {
      let filter = new URLSearchParams()

      if (props.searchParams && props.searchParams.length > 0) {
        const pluck = (array, key) => array.map((o) => o[key])
        const searchParamTypes = pluck(props.searchParams, 'type')

        for (const [key, value] of Object.entries(filterVal.value)) {
          if (!searchParamTypes.includes(key)) {
            filter.set(key, value)
          }
        }
      } else {
        for (const [key, value] of Object.entries(filterVal.value)) {
          filter.set(key, value)
        }
      }

      history.pushState(filter.toString(), '', '?' + filter)
    }

    const showMobileFilterFunction = () => {
      showMobileFilter.value = !showMobileFilter.value
    }

    const resetAllFilters = () => {
      if (filterVal.value && filterVal.value !== '') {
        Object.keys(filterVal.value).forEach((key) => {
          if (
            props.collectionFilter &&
            props.collectionFilter !== '' &&
            props.collectionFilter.includes(key)
          ) {
            filterVal.value[key] = '*'
          }
        })
        onFilterChange()
      }
    }

    const checkDisplayResetFilterBtn = () => {
      let valsArray = []
      Object.keys(filterVal.value).forEach((key) => {
        if (
          props.collectionFilter &&
          props.collectionFilter !== '' &&
          props.collectionFilter.includes(key)
        ) {
          if (filterVal.value[key] !== '*') {
            valsArray.push(filterVal.value[key])
          }
        }
      })

      displayResetBtn.value = valsArray.length > 0
    }

    return {
      showMobileFilter,
      showNoItemsFound,
      loadedAllItemFound,
      observer,
      totalItems,
      totalLoadedItems,
      catFilters,
      filterVal,
      showLazyLoadSpinner,
      data,
      itemContentArray,
      fetchDataParams,
      flickityOptions,
      displayResetBtn,
      isAuthenticated,
      contentGridFilterCollectionElem,
      onElementObserved,
      changeFilterTitle,
      onFilterChange,
      onFilterClick,
      fetchUserTraining,
      processFetch,
      changeFetchParams,
      changeUrlParameters,
      showMobileFilterFunction,
      resetAllFilters,
      checkDisplayResetFilterBtn,
      successPercentage,
      totalTrainings,
      successfulTrainings
    }
  }
})
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>

<style lang="scss">
@media only screen and (max-width: 1220px) {
  .btns-wrapper {
    .flickity-viewport {
      overflow: visible !important;

      .flickity-cell {
        width: auto;
        margin-right: 15px;
      }
    }
  }
}
</style>
